import { httpService } from "../core/services/http.service";
import { PaymentsDO } from "./profile.models";

class ProfileService {
    async getBillingData(): Promise<PaymentsDO | null> {
        httpService.setAuth(localStorage.getItem('tbw-auth-infos') || '')
        const response = await httpService.query('profile', {
            method: 'GET'
        });
        if (response.status !== 200) {
            return null;
        }
        return await response.json() as PaymentsDO;
    }
}

export const profileService = new ProfileService();
